import React, { useEffect, useState, useRef } from "react";
import { motion, useInView, useMotionValue, animate } from "framer-motion";

const STATS = [
  { value: 250, suffix: "+", label: "Logements livrés" },
  { value: 95, suffix: " %", label: "Clients satisfaits" },
  { value: 50_000, suffix: " m²", label: "Construits depuis 2015" },
  { value: 12, suffix: " ans", label: "D'expertise" },
];

function StatItem({ value, suffix, label, delay = 0 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });
  const motionVal = useMotionValue(0);
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (inView) {
      const controls = animate(motionVal, value, {
        duration: 1.4,
        delay,
        ease: [0.16, 1, 0.3, 1],
        onUpdate: (v) => setDisplay(Math.round(v)),
      });
      return () => controls.stop();
    }
  }, [inView, value, delay, motionVal]);

  return (
    <div ref={ref} className="text-center">
      <div className="font-display text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-none tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
        {display.toLocaleString("fr-FR")}{suffix}
      </div>
      <div className="text-xs md:text-sm uppercase tracking-[0.2em] text-white/60 font-semibold mt-3">{label}</div>
    </div>
  );
}

export default function StatsBand() {
  return (
    <section className="relative bg-[#0F1A3D] py-16 lg:py-20 overflow-hidden" data-testid="stats-band">
      {/* Decorative grain */}
      <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence baseFrequency='0.9'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")" }} />
      {/* Accent line */}
      <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-[#E91E63] to-transparent" />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12 lg:mb-14"
        >
          <div className="text-[12px] text-[#E91E63] font-bold tracking-[0.3em] mb-2">// CHIFFRES CLÉS</div>
          <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-white tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            TPCO en quelques chiffres
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4">
          {STATS.map((s, i) => (
            <StatItem key={s.label} {...s} delay={i * 0.1} />
          ))}
        </div>
      </div>
    </section>
  );
}
